import { useCallback, useEffect, useState } from 'react';
import Input from '../../form/Input';
import BigButton from '../../button/BigButton';
import { useLoginStore } from '../../../store/useLogin';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';
import RegistrationModal from './RegistrationModal';

/**
 * @author taulmax
 * @date 2024.10.07
 * @description 로그인 페이지
 */
const Login = () => {
  const { isAuthenticated, login } = useLoginStore();
  const navigate = useNavigate();

  const [isRegistration, setIsRegistration] = useState<boolean>(false);

  const onClickRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setIsRegistration(true);
  };

  useEffect(() => {
    if (isAuthenticated) {
      const lastPath = localStorage.getItem('lastPath');
      const location = lastPath ? lastPath : '/';
      navigate(location);
    }
  }, [isAuthenticated, navigate]);

  return (
    <div 
      className="!min-h-screen !w-full !flex"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(${require('../../../assets/img/login_bg.webp')})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      {/* 왼쪽 로그인 영역 */}
      <div className="!w-full md:!w-1/2 !min-h-screen !bg-white !bg-opacity-90 !flex !flex-col !items-center !justify-center !relative">
        <div className="!w-full !max-w-md !px-8">
          {/* 로고 영역 */}
          <div className="!text-center !mb-12">
            <div 
              className="!w-80 !h-48 !mx-auto"
              style={{
                backgroundImage: `url(${require('../../../assets/img/saju_logo.png')})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain'
              }}
            />
          </div>
          
          {/* 로그인 폼 - 개선된 디자인 */}
          <div className="!bg-white !rounded-3xl !shadow-2xl !p-10 !border !border-gray-100 !mb-8 md:!mb-16" style={{
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }}>
            <LoginForm
              isRegistration={isRegistration}
              setIsRegistration={setIsRegistration}
            />
          </div>

          {/* 모바일 푸터 - 간략 버전 */}
          <footer className="!block md:!hidden !text-center !text-[10px] !text-gray-500 !pb-6">
            <div>Fortune LAB | 주식회사 앤유코퍼레이션 | 대표 : 원현우</div>
            <div className="!mt-1">사업자등록번호 : 411-86-03841</div>
            <div className="!mt-1">© Fortune LAB All rights reserved.</div>
          </footer>
        </div>
        
        {/* 사주톡톡 텍스트 - 왼쪽 하단 (데스크톱만) */}
        <div className="!hidden md:!block !absolute !left-9 !bottom-9 !text-2xl !font-bold" style={{ fontFamily: 'SSRockRegular' }}>
          Fortune LAB
        </div>
      </div>

      {/* 오른쪽 회사 정보 영역 (데스크톱만) */}
      <footer className="!hidden md:!block !absolute !right-9 !bottom-9 !text-xs !text-gray-600 !bg-white !bg-opacity-60 !p-3 !rounded-lg !backdrop-blur-sm">
        <div className="!text-right">상호명 : 주식회사 앤유코퍼레이션 | 서비스명 : Fortune LAB | 대표 : 원현우</div>
        <div className="!text-right !mt-1">주소 : 서울특별시 금천구 디지털로10길 78, 1224호</div>
        <div className="!text-right !mt-1">사업자등록번호 : 411-86-03841 | E-mail : wonhw12100@naver.com</div>
        <div className="!text-right !mt-1">Copyright © Fortune LAB All rights reserved.</div>
      </footer>
      
      <RegistrationModal
        isRegistration={isRegistration}
        setIsRegistration={setIsRegistration}
      />
    </div>
  );
};

export default Login;
